const list = [
	{ code: '_somaliland', label: t('privacy', 'Somaliland') },
	{ code: 'ae', label: t('privacy', 'United Arab Emirates') },
	{ code: 'af', label: t('privacy', 'Afghanistan') },
	{ code: 'al', label: t('privacy', 'Albania') },
	{ code: 'am', label: t('privacy', 'Armenia') },
	{ code: 'ao', label: t('privacy', 'Angola') },
	{ code: 'ar', label: t('privacy', 'Argentina') },
	{ code: 'at', label: t('privacy', 'Austria') },
	{ code: 'au', label: t('privacy', 'Australia') },
	{ code: 'az', label: t('privacy', 'Azerbaijan') },
	{ code: 'ba', label: t('privacy', 'Bosnia and Herzegowina') },
	{ code: 'bd', label: t('privacy', 'Bangladesh') },
	{ code: 'be', label: t('privacy', 'Belgium') },
	{ code: 'bf', label: t('privacy', 'Burkina Faso') },
	{ code: 'bg', label: t('privacy', 'Bulgaria') },
	{ code: 'bi', label: t('privacy', 'Burundi') },
	{ code: 'bj', label: t('privacy', 'Benin') },
	{ code: 'bn', label: t('privacy', 'Brunei') },
	{ code: 'bo', label: t('privacy', 'Bolivia') },
	{ code: 'br', label: t('privacy', 'Brazil') },
	{ code: 'bs', label: t('privacy', 'Bahamas') },
	{ code: 'bt', label: t('privacy', 'Bhutan') },
	{ code: 'bw', label: t('privacy', 'Botswana') },
	{ code: 'by', label: t('privacy', 'Belarus') },
	{ code: 'bz', label: t('privacy', 'Belize') },
	{ code: 'ca', label: t('privacy', 'Canada') },
	{ code: 'cd', label: t('privacy', 'Democratic Republic of the Congo') },
	{ code: 'cf', label: t('privacy', 'Central African Republic') },
	{ code: 'cg', label: t('privacy', 'Congo') },
	{ code: 'ch', label: t('privacy', 'Switzerland') },
	{ code: 'ci', label: t('privacy', 'Cote d\'Ivoire') },
	{ code: 'cl', label: t('privacy', 'Chile') },
	{ code: 'cm', label: t('privacy', 'Cameroon') },
	{ code: 'cn', label: t('privacy', 'China') },
	{ code: 'co', label: t('privacy', 'Colombia') },
	{ code: 'cr', label: t('privacy', 'Costa Rica') },
	{ code: 'cu', label: t('privacy', 'Cuba') },
	{ code: 'cy', label: t('privacy', 'Cyprus') },
	{ code: 'cz', label: t('privacy', 'Czech') },
	{ code: 'de', label: t('privacy', 'Germany') },
	{ code: 'dj', label: t('privacy', 'Djibouti') },
	{ code: 'dk', label: t('privacy', 'Denmark') },
	{ code: 'do', label: t('privacy', 'Dominican Republic') },
	{ code: 'dz', label: t('privacy', 'Algeria') },
	{ code: 'ec', label: t('privacy', 'Ecuador') },
	{ code: 'ee', label: t('privacy', 'Estonia') },
	{ code: 'eg', label: t('privacy', 'Egypt') },
	{ code: 'eh', label: t('privacy', 'West Sahara') },
	{ code: 'er', label: t('privacy', 'Eritrea') },
	{ code: 'es', label: t('privacy', 'Spain') },
	{ code: 'et', label: t('privacy', 'Ethiopia') },
	{ code: 'fi', label: t('privacy', 'Finland') },
	{ code: 'fj', label: t('privacy', 'Fiji') },
	{ code: 'fk', label: t('privacy', 'Falkland Islands') },
	{ code: 'fr', label: t('privacy', 'France') },
	{ code: 'ga', label: t('privacy', 'Gabon') },
	{ code: 'gb', label: t('privacy', 'United Kingdom') },
	{ code: 'ge', label: t('privacy', 'Georgia') },
	{ code: 'gh', label: t('privacy', 'Ghana') },
	{ code: 'gl', label: t('privacy', 'Greenland') },
	{ code: 'gm', label: t('privacy', 'Gambia') },
	{ code: 'gn', label: t('privacy', 'Guinea') },
	{ code: 'gq', label: t('privacy', 'Equatorial Guinea') },
	{ code: 'gr', label: t('privacy', 'Greece') },
	{ code: 'gt', label: t('privacy', 'Guatemala') },
	{ code: 'gw', label: t('privacy', 'Guinea-Bissau') },
	{ code: 'gy', label: t('privacy', 'Guyana') },
	{ code: 'hn', label: t('privacy', 'Honduras') },
	{ code: 'hr', label: t('privacy', 'Croatia') },
	{ code: 'ht', label: t('privacy', 'Haiti') },
	{ code: 'hu', label: t('privacy', 'Hungary') },
	{ code: 'id', label: t('privacy', 'Indonesia') },
	{ code: 'ie', label: t('privacy', 'Ireland') },
	{ code: 'il', label: t('privacy', 'Israel') },
	{ code: 'in', label: t('privacy', 'India') },
	{ code: 'iq', label: t('privacy', 'Iraq') },
	{ code: 'ir', label: t('privacy', 'Iran') },
	{ code: 'is', label: t('privacy', 'Iceland') },
	{ code: 'it', label: t('privacy', 'Italy') },
	{ code: 'jm', label: t('privacy', 'Jamaica') },
	{ code: 'jo', label: t('privacy', 'Jordan') },
	{ code: 'jp', label: t('privacy', 'Japan') },
	{ code: 'ke', label: t('privacy', 'Kenya') },
	{ code: 'kg', label: t('privacy', 'Kyrgyzstan') },
	{ code: 'kh', label: t('privacy', 'Cambodia') },
	{ code: 'kp', label: t('privacy', 'North Korea') },
	{ code: 'kr', label: t('privacy', 'South Korea') },
	{ code: 'kw', label: t('privacy', 'Kuwait') },
	{ code: 'kz', label: t('privacy', 'Kazakhstan') },
	{ code: 'la', label: t('privacy', 'Laos') },
	{ code: 'lb', label: t('privacy', 'Lebanon') },
	{ code: 'lk', label: t('privacy', 'Sri Lanka') },
	{ code: 'lr', label: t('privacy', 'Liberia') },
	{ code: 'ls', label: t('privacy', 'Lesotho') },
	{ code: 'lt', label: t('privacy', 'Lithuania') },
	{ code: 'lu', label: t('privacy', 'Luxembourg') },
	{ code: 'lv', label: t('privacy', 'Latvia') },
	{ code: 'ly', label: t('privacy', 'Libya') },
	{ code: 'ma', label: t('privacy', 'Morocco') },
	{ code: 'md', label: t('privacy', 'Moldova') },
	{ code: 'me', label: t('privacy', 'Montenegro') },
	{ code: 'mg', label: t('privacy', 'Madagascar') },
	{ code: 'mk', label: t('privacy', 'Macedonia') },
	{ code: 'ml', label: t('privacy', 'Mali') },
	{ code: 'mm', label: t('privacy', 'Myanmar') },
	{ code: 'mn', label: t('privacy', 'Mongolia') },
	{ code: 'mr', label: t('privacy', 'Mauritania') },
	{ code: 'mw', label: t('privacy', 'Malawi') },
	{ code: 'mx', label: t('privacy', 'Mexico') },
	{ code: 'my', label: t('privacy', 'Malaysia') },
	{ code: 'mz', label: t('privacy', 'Mozambique') },
	{ code: 'na', label: t('privacy', 'Namibia') },
	{ code: 'nc', label: t('privacy', 'New Caledonia') },
	{ code: 'ne', label: t('privacy', 'Niger') },
	{ code: 'ng', label: t('privacy', 'Nigeria') },
	{ code: 'ni', label: t('privacy', 'Nicaragua') },
	{ code: 'nl', label: t('privacy', 'Netherlands') },
	{ code: 'no', label: t('privacy', 'Norway') },
	{ code: 'np', label: t('privacy', 'Nepal') },
	{ code: 'nz', label: t('privacy', 'New Zealand') },
	{ code: 'om', label: t('privacy', 'Oman') },
	{ code: 'pa', label: t('privacy', 'Panama') },
	{ code: 'pe', label: t('privacy', 'Peru') },
	{ code: 'pg', label: t('privacy', 'Papua New Guinea') },
	{ code: 'ph', label: t('privacy', 'Philippines') },
	{ code: 'pk', label: t('privacy', 'Pakistan') },
	{ code: 'pl', label: t('privacy', 'Poland') },
	{ code: 'pr', label: t('privacy', 'Puerto Rico') },
	{ code: 'pt', label: t('privacy', 'Portugal') },
	{ code: 'py', label: t('privacy', 'Paraguay') },
	{ code: 'qa', label: t('privacy', 'Qatar') },
	{ code: 'ro', label: t('privacy', 'Romania') },
	{ code: 'rs', label: t('privacy', 'Serbia') },
	{ code: 'ru', label: t('privacy', 'Russia') },
	{ code: 'rw', label: t('privacy', 'Rwanda') },
	{ code: 'sa', label: t('privacy', 'Saudi Arabia') },
	{ code: 'sb', label: t('privacy', 'Solomon Islands') },
	{ code: 'sd', label: t('privacy', 'Sudan') },
	{ code: 'se', label: t('privacy', 'Sweden') },
	{ code: 'sg', label: t('privacy', 'Singapore') },
	{ code: 'si', label: t('privacy', 'Slovenia') },
	{ code: 'sk', label: t('privacy', 'Slovakia') },
	{ code: 'sl', label: t('privacy', 'Sierra Leone') },
	{ code: 'sn', label: t('privacy', 'Senegal') },
	{ code: 'so', label: t('privacy', 'Somalia') },
	{ code: 'sr', label: t('privacy', 'Suriname') },
	{ code: 'ss', label: t('privacy', 'South Sudan') },
	{ code: 'sv', label: t('privacy', 'El Salvador') },
	{ code: 'sy', label: t('privacy', 'Syria') },
	{ code: 'sz', label: t('privacy', 'Swaziland') },
	{ code: 'td', label: t('privacy', 'Chad') },
	{ code: 'tf', label: t('privacy', 'Fr. S. Antarctic Lands') },
	{ code: 'tg', label: t('privacy', 'Togo') },
	{ code: 'th', label: t('privacy', 'Thailand') },
	{ code: 'tj', label: t('privacy', 'Tajikistan') },
	{ code: 'tl', label: t('privacy', 'Timor-Leste') },
	{ code: 'tm', label: t('privacy', 'Turkmenistan') },
	{ code: 'tn', label: t('privacy', 'Tunisia') },
	{ code: 'tr', label: t('privacy', 'Turkey') },
	{ code: 'tt', label: t('privacy', 'Trinidad and Tobago') },
	{ code: 'tw', label: t('privacy', 'Taiwan') },
	{ code: 'tz', label: t('privacy', 'Tanzania') },
	{ code: 'ua', label: t('privacy', 'Ukraine') },
	{ code: 'ug', label: t('privacy', 'Uganda') },
	{ code: 'us', label: t('privacy', 'United States') },
	{ code: 'uy', label: t('privacy', 'Uruguay') },
	{ code: 'uz', label: t('privacy', 'Uzbekistan') },
	{ code: 've', label: t('privacy', 'Venezuela') },
	{ code: 'vn', label: t('privacy', 'Vietnam') },
	{ code: 'vu', label: t('privacy', 'Vanuatu') },
	{ code: 'ye', label: t('privacy', 'Yemen') },
	{ code: 'za', label: t('privacy', 'South Africa') },
	{ code: 'zm', label: t('privacy', 'Zambia') },
	{ code: 'zw', label: t('privacy', 'Zimbabwe') },
]

export function getCountryList() {
	return list.sort((a, b) => a.label < b.label ? -1 : 1)
}

export function getNameForCountryCode(code) {
	const element = list.find((e) => e.code === code)
	if (element) {
		return element.label
	}

	return ''
}
